<script>
export default {
  props: {
    fullFeature: {
      type: Boolean,
      default: false,
      require: false,
    },
    dataTables: {
      type: Array,
      default: () => [],
      require: true,
    },
    tableFields: {
      type: Array,
      default: () => [],
      require: true,
    },
  },
  data() {
    return {
      preventSort: false,
    }
  },
  computed: {
    full() {
      if (this.fullFeature) {
        return {
          hover: '',
          sorter: '',
          border: '',
          striped: '',
          ...this.$attrs,
        }
      }
      return this.$attrs
    },
    computedItems() {
      return this.dataTables.map((item, id) => {
        return { ...item, id }
      })
    },
    computedFields() {
      return this.tableFields
    },
    fieldsKey() {
      return this.tableFields.map((item) => {
        if (item.slot) {
          return item.key
        }
      })
    },
  },
  mounted() {
    const tables = this.$refs.dataTableRefs.$el?.children[0]?.children[0]
    if (tables) {
      this.resizableGrid(tables)
    }
  },
  methods: {
    iconClasses(state) {
      return [
        'icon-transition arrow-position ml-2',
        {
          transparent: !state,
          'rotate-icon': state === 'asc',
        },
      ]
    },
    handleSorter({ asc, column }) {
      if (column === 'fist_email') {
        column = 'first_email'
      }
      this.$emit('sorterBy', asc ? column : `${column}-`)
    },
    resizableGrid(table) {
      const row = table.getElementsByTagName('tr')[0]
      const cols = row ? row.children : undefined
      if (!cols) return
      const tableHeight = table.offsetHeight
      for (let i = 0; i < cols.length; i++) {
        const div = createDiv(tableHeight)
        cols[i].appendChild(div)
        cols[i].style.position = 'relative'
        setListeners(div)
      }

      function setListeners(div) {
        let pageX, curCol, curColWidth, tableWidth

        div.addEventListener('mousedown', function(e) {
          tableWidth = table.offsetWidth
          curCol = e.target.parentElement
          pageX = e.pageX

          const padding = paddingDiff(curCol)

          curColWidth = curCol.offsetWidth - padding
        })

        div.addEventListener('mouseover', function(e) {
          e.target.style.borderRight = '2px solid #a8cf6a'
        })

        div.addEventListener('mouseout', function(e) {
          e.target.style.borderRight = ''
        })

        window.addEventListener('mousemove', function(e) {
          if (curCol) {
            const diffX = e.pageX - pageX
            curCol.style.width = curColWidth + diffX + 'px'
            table.style.width = tableWidth + diffX + 'px'
          }
        })

        window.addEventListener('mouseup', function(e) {
          curCol = undefined
          pageX = undefined
          curColWidth = undefined
        })
      }

      function createDiv(height) {
        const div = document.createElement('div')
        div.style.top = 0
        div.style.right = 0
        div.style.width = '5px'
        div.style.position = 'absolute'
        div.style.cursor = 'col-resize'
        div.style.userSelect = 'none'
        div.style.height = height + 'px'
        return div
      }

      function paddingDiff(col) {
        if (getStyleVal(col, 'box-sizing') === 'border-box') {
          return 0
        }

        const padLeft = getStyleVal(col, 'padding-left')
        const padRight = getStyleVal(col, 'padding-right')
        return parseInt(padLeft) + parseInt(padRight)
      }

      function getStyleVal(elm, css) {
        return window.getComputedStyle(elm, null).getPropertyValue(css)
      }
    },
  },
}
</script>

<template>
  <BaseCustomDataTable
    id="base-table-feelline"
    ref="dataTableRefs"
    v-bind="full"
    :items="computedItems"
    :fields="computedFields"
    outlined
    responsive
    class="mt-3"
    :sorter="{ external: true, resetable: false }"
    @update:sorter-value="handleSorter"
    v-on="$listeners"
  >
    <template v-for="slot in fieldsKey" v-slot:[slot]="slotProps">
      <slot :name="slot" v-bind="slotProps"></slot>
    </template>
    <template v-slot:no-items-view>
      <h4 class="text-center mb-0">データが存在しません</h4>
    </template>
  </BaseCustomDataTable>
</template>

<style lang="scss" scoped>
#base-table-feelline {
  min-height: 200px;
  ::v-deep table {
    min-width: 100%;
  }

  ::v-deep .form-check-input {
    transform: scale(1.5);
  }

  ::v-deep thead {
    color: $white;
    white-space: nowrap;
    background-color: $gray-base;
    div {
      display: inline-block;
    }
    tr {
      th {
        font-size: 12px;
      }
    }
  }
  ::v-deep .arrow-position {
    transform: unset;
  }
  ::v-deep .rotate-icon {
    transform: rotate(-180deg);
  }
  .table-custom-pagination {
    ::v-deep a {
      padding: 0;
      border: none;
    }
  }

  ::v-deep td {
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
    overflow-wrap: break-word;
    vertical-align: middle;

    &:first-child {
      .form-check-input {
        position: relative;
      }
    }
  }
}
</style>
